import React from 'react';
import { STag, STooltip, SIcon } from '@avalara/skylab-sdk/react';
import { ProcessingStatusColorMap, resolveStatusKey, getProcessingStatusLabel } from '../../../utils/uploadedDocumentsHelper';

const ProcessingStatusTag = ({ document, showReason, languages }) => {
    const statusKey = resolveStatusKey(document.processingStatus);
    const statusLabel = getProcessingStatusLabel(languages, statusKey);
    const statusColor = ProcessingStatusColorMap[statusKey];

    if (!statusLabel) {
        return null;
    }

    return (
        <div className="flex align-items-center">
            <STag color={statusColor} style={{ minWidth: '7rem', justifyContent: 'center' }}><span slot="content">{statusLabel}</span></STag>
            {showReason && document.reason && (
                <>
                    <SIcon id={`status-icon-${document.id}`} name="info-circle" style={{ marginInlineStart: '0.25rem', verticalAlign: 'middle', cursor: 'pointer' }} />
                    <STooltip triggerId={`status-icon-${document.id}`} tooltipId={`status-tooltip-${document.id}`}>
                        <span slot="content">{document.reason}</span>
                    </STooltip>
                </>
            )}
        </div>
    );
};


ProcessingStatusTag.defaultProps = {
    showReason: true,
    languages: {}
};

export default ProcessingStatusTag;
